import { DialogHeader } from '@/components/ui/dialog'
import { Loader2, PenLine, Wallet } from 'lucide-react'
import { useTranslations } from 'next-intl'
import { ErrorMessage } from './error-message'
import { StepTitleSection } from './step-title-section'

type WalletSigningStepProps = {
	step: 'signing' | 'verifying'
	error: string | null
}

const iconForStep = {
	signing: PenLine,
	verifying: Wallet,
} as const

export function WalletSigningStep({ step, error }: WalletSigningStepProps) {
	const t = useTranslations('auth')
	const Icon = iconForStep[step]
	const titleKey = step === 'signing' ? 'signingTitle' : 'verifyingTitle'
	const descriptionKey = step === 'signing' ? 'signingDescription' : 'verifyingDescription'

	return (
		<>
			<DialogHeader>
				<StepTitleSection title={t(titleKey)} description={t(descriptionKey)} />
			</DialogHeader>

			<div className="flex flex-col items-center justify-center gap-[24px] py-[16px]">
				<div className="relative flex h-[96px] w-[96px] items-center justify-center rounded-full bg-blue-500/15">
					<Icon className="size-[40px] text-blue-400" strokeWidth={1.75} />
					<div className="absolute inset-0 animate-spin rounded-full border-2 border-blue-500/25 border-t-blue-400" />
				</div>

				<div className="flex items-center gap-[8px] text-brand-gray-secondary">
					<Loader2 className="size-[14px] animate-spin text-blue-400" />
					<span className="text-[13px]">{t('waitingForWallet')}</span>
				</div>

				<ErrorMessage error={error} />
			</div>
		</>
	)
}
